import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonsCancelComponent } from '@app/shared/components/buttons/cancel/buttons-cancel.component';
import { ButtonsSubmitComponent } from '@app/shared/components/buttons/submit/buttons-submit.component';
import { DialogFooterComponent } from '@app/shared/components/dialog/dialog-footer/dialog-footer.component';
import { DialogHeaderComponent } from '@app/shared/components/dialog/dialog-header/dialog-header.component';

@Component({
  selector: 'hypecast-admin-form-deactivateable-dialog',
  templateUrl: './form-deactivateable-dialog.component.html',
  styleUrl: './form-deactivateable-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DialogFooterComponent,
    DialogHeaderComponent,
    MatButtonModule,
    ButtonsCancelComponent,
    ButtonsSubmitComponent,
  ],
})
export class FormDeactivateableDialogComponent {
  readonly dialogRef = inject<MatDialogRef<FormDeactivateableDialogComponent>>(MatDialogRef);
}
